module.exports = __webpack_public_path__ + "img/indexa.dfe47613.png";